import { GreenhouseDepartment } from "../types";

const filterEmptyDepartments = (department: GreenhouseDepartment) => department?.jobs?.length > 0;

export { filterEmptyDepartments };
